/**
 * History 列表 Fixture 数据
 * 覆盖任务: T-H1/T-H2/T-H3/T-H4/T-H5/T-H6
 */

const nowIso = () => new Date().toISOString();

const toTrimmedString = (value) => {
    const normalized = String(value || '').trim();
    return normalized || null;
};

/**
 * Subject-first 条目（新主链路）
 */
export const historySubjects = [
    {
        subject_id: 'sub_hist_001',
        hash_id: 'hash_abc_001',
        is_legacy: false,
        current_visible_result_status: 'ready',
        preview_image_url: '/mock/history_001.png',
        reference_code: 'reference_1',
        preset_style_id: 'reference_1',
        relation_status: 'active',
        created_at: '2024-01-10T08:00:00Z',
        updated_at: '2024-01-10T08:05:00Z'
    },
    {
        subject_id: 'sub_hist_002',
        hash_id: 'hash_def_002',
        is_legacy: false,
        current_visible_result_status: 'pending',
        preview_image_url: '/mock/history_002.png',
        reference_code: 'reference_2',
        preset_style_id: 'reference_2',
        relation_status: 'active',
        created_at: '2024-01-12T14:30:00Z',
        updated_at: '2024-01-12T14:32:00Z'
    },
    {
        subject_id: 'sub_hist_003',
        hash_id: 'hash_ghi_003',
        is_legacy: false,
        current_visible_result_status: 'error',
        preview_image_url: '/mock/history_003.png',
        reference_code: 'reference_3',
        preset_style_id: 'reference_3',
        relation_status: 'active',
        created_at: '2024-01-14T09:15:00Z',
        updated_at: '2024-01-14T09:15:00Z'
    },
    {
        subject_id: 'sub_hist_004',
        hash_id: 'hash_jkl_004',
        is_legacy: false,
        current_visible_result_status: 'ready',
        preview_image_url: '/mock/history_004.png',
        reference_code: 'reference_4',
        preset_style_id: 'reference_4',
        relation_status: 'active',
        created_at: '2024-01-15T16:20:00Z',
        updated_at: '2024-01-15T16:25:00Z'
    }
];

/**
 * Legacy 条目（无 subject_id）
 */
export const historyLegacyItems = [
    {
        subject_id: null,
        hash_id: 'hash_legacy_xyz',
        is_legacy: true,
        current_visible_result_status: 'ready',
        preview_image_url: '/mock/history_legacy.png',
        reference_code: null,
        preset_style_id: 'portrait_studio_old',
        relation_status: 'active',
        created_at: '2023-12-01T10:00:00Z',
        updated_at: '2023-12-01T10:05:00Z'
    },
    {
        subject_id: null,
        hash_id: 'hash_legacy_deleted',
        is_legacy: true,
        current_visible_result_status: 'error',
        preview_image_url: '/mock/history_deleted.png',
        reference_code: null,
        preset_style_id: 'landscape_nature_old',
        relation_status: 'deleted',
        created_at: '2023-11-15T10:00:00Z',
        updated_at: '2023-11-15T10:05:00Z'
    },
    {
        subject_id: null,
        hash_id: 'hash_legacy_conflict',
        is_legacy: true,
        current_visible_result_status: 'ready',
        preview_image_url: '/mock/history_conflict.png',
        reference_code: null,
        preset_style_id: 'street_urban_old',
        relation_status: 'active',
        created_at: '2023-10-20T08:00:00Z',
        updated_at: '2023-10-20T08:10:00Z'
    }
];

/**
 * Solo 条目（无 reference）
 */
export const historySoloItems = [
    {
        subject_id: null,
        hash_id: 'hash_solo_001',
        is_legacy: false,
        current_visible_result_status: 'ready',
        preview_image_url: '/mock/history_solo.png',
        reference_code: null,
        preset_style_id: null,
        relation_status: 'active',
        created_at: '2024-01-14T09:00:00Z',
        updated_at: '2024-01-14T09:05:00Z'
    },
    {
        subject_id: null,
        hash_id: 'hash_solo_002',
        is_legacy: false,
        current_visible_result_status: 'pending',
        preview_image_url: '/mock/history_solo_2.png',
        reference_code: null,
        preset_style_id: null,
        relation_status: 'active',
        created_at: '2024-01-16T11:30:00Z',
        updated_at: '2024-01-16T11:35:00Z'
    }
];

/**
 * T-H6: 403/404/409/410 状态机测试数据
 */
export const historySpecialItems = {
    forbidden: [
        {
            hash_id: 'hash_forbidden_001',
            reason: 'access_denied',
            owner_id: 'other_user'
        }
    ],
    deleted: [
        {
            hash_id: 'hash_permanently_deleted',
            deleted_at: '2023-10-01T00:00:00Z',
            reason: 'user_request'
        }
    ],
    notFound: [
        {
            hash_id: 'hash_not_found',
            reason: 'never_existed'
        }
    ]
};

const buildHistorySummaryResultItem = (item = {}) => ({
    hash_id: item.hash_id,
    subject_id: item.subject_id,
    is_legacy: item.is_legacy,
    current_visible_result_status: item.current_visible_result_status,
    preview_image_url: item.preview_image_url,
    reference_code: item.reference_code,
    created_at: item.created_at,
    updated_at: item.updated_at,
    preset_style_id: item.preset_style_id || null,
    relation_status: item.relation_status || null
});

const getReferenceImageUrl = (referenceCode) => {
    if (!referenceCode) return null;
    // 将 reference_1 映射到 ref1.jpg，reference_2 映射到 ref2.jpg 等
    const match = referenceCode.match(/reference_(\d+)/);
    if (match) {
        const index = parseInt(match[1], 10);
        const fileMap = {
            1: 'ref1.jpg', 2: 'ref2.jpg', 3: 'ref3.jpeg', 4: 'ref4.png',
            5: 'ref5.png', 6: 'ref6.webp', 7: 'ref7.jpg', 8: 'ref8.jpg',
            9: 'ref9.jpg', 10: 'ref10.png'
        };
        const file = fileMap[index];
        if (file) return `/data/references/${file}`;
    }
    return `/data/references/${referenceCode}.jpg`;
};

const buildHistoryDetailItem = (item = {}) => ({
    relation_group_id: item.hash_id,
    user_image_relation_id: `rel_${item.hash_id}`,
    user_id: 'mock_user_001',
    hash_id: item.hash_id,
    created_at: item.created_at,
    updated_at: item.updated_at,
    subject_id: item.subject_id,
    is_legacy: item.is_legacy,
    current_visible_result_status: item.current_visible_result_status,
    reference_code: item.reference_code,
    original_image: {
        hash_id: item.hash_id,
        image_url: item.preview_image_url,
        file_type: 'png',
        image_type: 'original'
    },
    processed_image: {
        hash_id: item.hash_id,
        image_url: item.preview_image_url,
        file_type: 'png',
        image_type: 'processed'
    },
    relation_meta: {
        preset_style_id: item.preset_style_id || null,
        reference_code: item.reference_code || null,
        reference_image_url: getReferenceImageUrl(item.reference_code)
    }
});

const buildHistoryGroup = (item = {}) => ({
    relation_group_id: item.hash_id,
    original_hash_id: item.hash_id,
    created_at: item.created_at,
    updated_at: item.updated_at,
    subject_id: item.subject_id,
    is_legacy: item.is_legacy,
    current_visible_result_status: item.current_visible_result_status,
    refs: [
        {
            relation_id: `rel_${item.hash_id}`,
            display_hash_id: item.hash_id,
            preset_style_id: item.preset_style_id || null,
            reference_image_url: item.reference_code
                ? getReferenceImageUrl(item.reference_code)
                : item.preview_image_url,
            subject_id: item.subject_id,
            is_legacy: item.is_legacy,
            current_visible_result_status: item.current_visible_result_status,
            reference_code: item.reference_code,
            created_at: item.created_at,
            updated_at: item.updated_at
        }
    ]
});

/**
 * 生成标准 History 响应格式。
 * 兼容 relationGateway 的三种消费路径：detail/history_groups/results。
 */
export const buildHistoryListResponse = (items = null) => {
    const allItems = items || [
        ...historySubjects,
        ...historyLegacyItems,
        ...historySoloItems
    ];

    return {
        user_id: 'mock_user_001',
        query_status: 'ok',
        relation_count: allItems.length,
        detail: allItems.map(buildHistoryDetailItem),
        history_groups: allItems.map(buildHistoryGroup),
        results: allItems.map(buildHistorySummaryResultItem),
        count: allItems.length,
        next: null,
        previous: null,
        fetched_at: nowIso()
    };
};

export const findHistoryItemByHashId = (hashId) => {
    const normalizedHashId = toTrimmedString(hashId);
    if (!normalizedHashId) {
        return null;
    }

    const allItems = [
        ...historySubjects,
        ...historyLegacyItems,
        ...historySoloItems
    ];

    return allItems.find((item) => item.hash_id === normalizedHashId) || null;
};

export const findHistoryItemBySubjectId = (subjectId) => {
    const normalizedSubjectId = toTrimmedString(subjectId);
    if (!normalizedSubjectId) {
        return null;
    }

    return historySubjects.find((item) => item.subject_id === normalizedSubjectId) || null;
};
